import { Component, DestroyRef, inject, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ModalService, ModalSize } from '@ftr/foundation'
import { Store } from '@ngxs/store'
import { UserState } from '../../store'

@Component({
  selector: 'ftr-multifactor-recovery-code-modal',
  templateUrl: './recovery-code-modal.component.html',
  standalone: false,
})
export class RecoveryCodeModalComponent implements OnInit {
  @Input() regenerate: boolean = false
  @ViewChild('recoveryCodesModalComponent') recoveryCodesModalComponent: TemplateRef<any>

  readonly modalSizes = ModalSize
  readonly #destroyRef = inject(DestroyRef)

  constructor(
    private readonly modalService: ModalService,
    private readonly store: Store,
    private readonly modalContainer: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.observeOpenState()
  }

  private observeOpenState(): void {
    this.store
      .select(UserState.showingMfaRecoveryCodeModal)
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(modalOpen => {
        if (modalOpen) {
          this.modalService.open(this.recoveryCodesModalComponent, this.modalContainer)
        } else {
          this.modalService.close()
        }
      })
  }
}
